import React, { useState } from "react";
import { Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const CheckItemPopup = (props) => {
    const { t } = useTranslation("translation");

    const [state, setState] = useState({
        name: "",
        note: "",
    });

    const handleChange = (evt) => {
        const name = evt.target.id;
        const value = evt.target.value;
        setState({
            ...state,
            [name]: value,
        });
    };

    return (
        <Container>
            <Dialog open={props.open} onClose={props.onCancel} fullWidth maxWidth="xs">
                <DialogTitle>{t("AddCheckItem")}</DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container direction={"column"} spacing={3}>
                        <Grid item>
                            <TextField id="name" label={t("Name")} variant="outlined" onChange={handleChange} fullWidth />
                        </Grid>
                        <Grid item>
                            <TextField id="note" label={t("Note")} variant="outlined" onChange={handleChange} fullWidth />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button id="cancel_button" onClick={props.onCancel} color="primary">
                        {t("Cancel")}
                    </Button>
                    <Button id="add_button" onClick={() => props.onAdd(state.name, state.note)} color="primary">
                        {t("Add")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default CheckItemPopup;
